import { useCallback, useContext, useState } from "react";
import { DonatePageContext } from "../../../context/DonatePageContext";
import useModal from "../../../customHooks/useModal";
import InfinteDataSoruceHandler from "../../SharedLayoutComponents/InfinteDataSoruceHandler";
import DonationAccordionSkeleton from "../../Skeletons/DonationAccordionSkeleton";
import DonationDetailsCard from "../DonationDetailsCard";
import DonationDetailsModal from "../DonationDetailsModal";

const DonationAccordionTab = () => {
  const [clickedDonationObj, setClickedDonationObj] = useState(null);

  const {
    showModal: showModalOffCanvas,
    handleCloseModal: handleCloseModalOffCanvas,
    handleShowModal: handleShowModalOffCanvas,
  } = useModal();

  const onDonationCardClick = useCallback((donationObj) => {
    setClickedDonationObj(donationObj);
    handleShowModalOffCanvas();
  }, []);

  const { url } = useContext(DonatePageContext);
  return (
    <>
      <InfinteDataSoruceHandler
        skeleton={DonationAccordionSkeleton}
        endPoint={`${url?.endPoint}/${url?.id}/donations`}
        resourceName="donation"
        skeletonAmount={6}
        getMoreSkeletonAmount={4}
        inifiteScrollProps={{ no100vh: true, className: "mb-6" }}
      >
        <DonationDetailsCard
          onDonationCardClick={onDonationCardClick}
          selectedItems={["amount", "email", "name", "receipt_id"]}
        />
      </InfinteDataSoruceHandler>
      <DonationDetailsModal
        details={clickedDonationObj?.details}
        open={showModalOffCanvas}
        handleClose={handleCloseModalOffCanvas}
      />
    </>
  );
};

export default DonationAccordionTab;
